export const dispatchEventSendContact = data => {
  const { contactForm: { listingId } } = data

  global.dispatchEvent(new CustomEvent('send-contact', { detail: { listingId } }))
}

export const dispatchEventFetchListings = data => {
  global.dispatchEvent(new CustomEvent('fetch-listings', data))
}

export const dispatchEventRemovePolygon = () => {
  global.dispatchEvent(new CustomEvent('remove-polygon'))
}
